<template>
  <div class="login">
    <v-card >
      <v-row >
        <v-col cols="6">
          <v-img :src="require('@/assets/lleft.png')"></v-img>
        </v-col>
        <v-col cols="6">
          <div style="font-size: 28px;font-weight: 500">诺莱医学在线诊疗管理平台</div>
          <div style="color: #ccc">Welcome 欢迎登录</div>
          <div style="margin-top: 30px">
            <input v-model="username" type="text" placeholder="请输入用户名" class="username">
          </div>
          <div style="margin-top: 30px">
            <input v-model="password" type="password" placeholder="请输入密码" class="password">
          </div>
          <div style="margin-top: 60px">
            <v-btn shape="circle" style="width: 80%" @click="login()">立即登录</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  import api from "../api";
  export default {
    name: "Login",
    data: function(){
      return {
        username: '',
        password: ''
      }
    },
    methods: {
      login: function(){
        this.$http.post(api.login, {name: this.username, password: this.password}).then(response => {
          if(response.data.success) {
             this.$router.replace('/interview');
             localStorage.setItem('user_name', response.data.name);
             localStorage.setItem('uid', response.data.uid);
             response.data.rid ? localStorage.setItem('rid', response.data.rid) : localStorage.setItem('rid', '0');
          } else {
            this.$store.dispatch('snkbar', {show: true, txt: response.data.err});
          }
        })
      }
    }
  }
</script>

<style scoped>
  .login {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    background-image: url("~@/assets/lbg1.jpg");
    background-repeat:no-repeat;
    background-size: cover;
  }
  .username {
    outline-style: none;
    border: 0;
    border-bottom: 1px solid #ccc;
    padding: 15px 15px 15px 40px;
    width: 80%;
    font-size: 16px;
    background:url("~@/assets/username.png") center left no-repeat;
  }
  .password {
    outline-style: none;
    border: 0;
    border-bottom: 1px solid #ccc;
    padding: 15px 15px 15px 40px;
    width: 80%;
    font-size: 16px;
    background:url("~@/assets/password.png") center left no-repeat;
  }
  input::-webkit-input-placeholder {
    color: #ccc;
  }
</style>
